import React from 'react'
import { find } from 'lodash'
import { replaceExpression } from '../utils'

export default class PrintCheckBoxQuestion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            allComments: [],
        }
    }

    getValue(optionId) {
        const value = find(this.props.state, (s) => s.optionId === optionId)
        return value ? value.booleanValue : false
    }

    getOriginalValue(optionId) {
        let value = undefined
        if (this.props.originalState) {
            value = find(this.props.originalState, (s) => s.optionId === optionId)
        }
        return value ? value.booleanValue : false
    }

    getCommentForQuestion(questionId) {
        const { allComments } = this.props
        const comment = allComments.find((c) => c.questionId === questionId)
        return comment ? comment.comment : null
    }

    render() {
        const { data, answermap } = this.props
        const tableStyle = {
            fontSize: '10px',
        }

        const questionComment = this.getCommentForQuestion(data.id)

        return (
            <div className="question-group type-checkbox">
                <p style={{ fontSize: '15px', lineHeight: '1.3em' }}>
                    {replaceExpression(data.questionText, answermap)}
                </p>
                <div
                    style={{
                        fontSize: '11px',
                        fontStyle: 'italic',
                        lineHeight: '1.4em',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: replaceExpression(data.explanation, answermap),
                    }}
                />
                <table style={tableStyle} width="100%">
                    <tbody>
                    <tr>
                        <td width="60%">
                            <span>&nbsp;</span>
                        </td>
                        <td width="20%">Ingevuld</td>
                        <td width="20%">Aangepast</td>
                    </tr>
                    {data.options.map((option, i) => (
                        <tr key={i + option.id}>
                            <td>
                                <div className="text">
                                    {replaceExpression(option.optionText, answermap)}
                                </div>
                            </td>
                            <td>
                                {this.getOriginalValue(option.id) && <div>x</div>}
                                <span>&nbsp;</span>
                            </td>
                            <td>
                                {this.getValue(option.id) && <div>x</div>}
                                <span>&nbsp;</span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                {questionComment && (
                    <div
                        style={{
                            paddingTop: '5px',
                            fontSize: '15px',
                            fontStyle: 'italic',
                            marginBottom: '20px',
                        }}
                    >
                        <strong>Toelichting:</strong> {questionComment}
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PrintCheckBoxQuestion.js